module.exports = __webpack_public_path__ + "img/directViaFlight.f8623f0a.svg";